import { useState } from "react";
import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import {
    FolderIcon,
    ChevronRightIcon,
    XMarkIcon,
    DocumentIcon,
} from "@heroicons/react/24/outline";
import { FormattedMessage } from "react-intl";

interface FilesModalInterface {
    files: { publicUrl: string; id: string; filename: string }[];
}

export default function FilesModal({ files }: FilesModalInterface) {
    const [open, setOpen] = useState(false);
    return (
        <>
            <button className="group" onClick={() => setOpen(true)}>
                <div className="bg-white group-hover:bg-gray-100 border border-gray-300 rounded-sm p-4 flex flex-col">
                    <div className="flex flex-col justify-between">
                        <div className="pb-2">
                            <FolderIcon className="size-6" />
                        </div>
                        <div className="flex justify-between items-center text-gray-900">
                            <span className="text-2xl font-medium">
                                <FormattedMessage id="Additional documents" />
                            </span>
                            <span className="-mr-3">
                                <ChevronRightIcon
                                    className="size-8"
                                    strokeWidth="1"
                                />
                            </span>
                        </div>
                    </div>
                </div>
            </button>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                className="relative z-999"
            >
                <div
                    className="fixed inset-0 bg-gray-500/75"
                    aria-hidden="true"
                />
                <div className="fixed inset-0 flex w-screen items-center justify-center p-8">
                    <DialogPanel className="w-full sm:max-w-lg rounded-sm bg-white p-8">
                        <div className="flex items-center">
                            <div className="mx-auto shrink-0 flex items-center justify-center size-12 rounded-full bg-rose-100 border-rose-100 border-4 sm:mx-0 sm:size-10">
                                <FolderIcon className="size-6 text-rose-600" />
                            </div>
                            <DialogTitle className="text-2xl leading-6 text-gray-900 font-light ml-4">
                                <FormattedMessage id="Files" />
                            </DialogTitle>
                            <button
                                onClick={() => setOpen(false)}
                                className="rounded-md bg-white text-gray-400 hover:text-gray-500 ml-auto"
                            >
                                <span className="sr-only">
                                    <FormattedMessage id="Close" />
                                </span>
                                <XMarkIcon className="size-6" />
                            </button>
                        </div>
                        <div className="pt-12 grid grid-cols-1 gap-5">
                            <>
                                {files.length ? (
                                    files.map((file) => (
                                        <a
                                            href={file.publicUrl}
                                            key={file.id}
                                            className="group"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <div className="bg-white group-hover:bg-gray-100 border border-gray-300 rounded-sm p-4 flex flex-col">
                                                <div className="flex flex-col justify-between">
                                                    <div className="flex justify-between items-center text-gray-900">
                                                        <span className="mr-3">
                                                            <DocumentIcon className="size-6" />
                                                        </span>
                                                        <span className="font-medium">
                                                            {file.filename}
                                                        </span>
                                                        <span className="-mr-3">
                                                            <ChevronRightIcon
                                                                className="size-8"
                                                                strokeWidth="1"
                                                            />
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    ))
                                ) : (
                                    <p>
                                        <FormattedMessage id="No files are available" />
                                    </p>
                                )}
                            </>
                        </div>
                    </DialogPanel>
                </div>
            </Dialog>
        </>
    );
}
